import script from "./AnnouncementsListPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsListPlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsListPlaceholder.vue?vue&type=style&index=0&id=6bcb5fda&lang=scss&scoped=true"
script.__scopeId = "data-v-6bcb5fda"

export default script